/***********************************************
 * useBrowserTabFlash
 *
 * Alternates the browser tab title with a given message.
 * Can be stopped when tab is back in focus.
 * Can stop after a set duration in seconds.
 *
 * startTabFlash(message, duration = -1, untilFocus = true)
 * stopTabFlash()
 ***********************************************/
import { onBeforeUnmount, ref } from "vue";
import { useDocumentVisibility, useTitle } from "@vueuse/core";
export const useBrowserTabFlash = () => {
    const originalPageTitle = document.title;
    const title = ref(originalPageTitle);
    let flashTitle = "";
    let count = 0;
    let limit = -1;
    let stopOnFocus = false;
    const tabFocused = useDocumentVisibility();
    useTitle(title);
    const startTabFlash = (message, duration, untilFocus) => {
        count = 0;
        limit = duration;
        flashTitle = message;
        stopOnFocus = untilFocus;
        setTimeout(flashTab, 1000);
    };
    const stopTabFlash = () => {
        limit = 0;
        title.value = originalPageTitle;
    };
    const flashTab = () => {
        count++;
        if ((stopOnFocus && tabFocused.value == "visible") || (limit >= 0 && count > limit)) {
            stopTabFlash();
        }
        else {
            title.value = count % 2 == 0 ? flashTitle : originalPageTitle;
            setTimeout(flashTab, 1000);
        }
    };
    onBeforeUnmount(() => {
        stopTabFlash();
    });
    return {
        startTabFlash,
        stopTabFlash
    };
};
